import { Box, BoxProps, SxProps } from '@mui/material';

import { withSxProp } from 'common/utils/props';

const dividerStyle: SxProps = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',

    '::before, ::after': {
        width: '100%',
        borderTop: 1,
        borderTopColor: 'divider',
        content: '""',
        transform: 'translateY(50%)',
    },

    '> *': {
        zIndex: 1,
        flex: '0 0 auto',
    },
};

interface IProps extends BoxProps {
    variant?: 'dashed' | 'solid';
}

export const Divider = ({ children, sx, variant, ...other }: IProps) => (
    <Box
        {...other}
        sx={[
            dividerStyle,
            {
                '::before, ::after': {
                    borderTop:
                        variant === 'dashed' ? '1px dashed' : '1px solid',
                    borderTopColor: 'divider',
                },
            },

            // Spread sx from props
            ...withSxProp(sx),
        ]}
    >
        {!!children && <Box sx={{ px: 1 }}>{children}</Box>}
    </Box>
);
